import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./payment-success.css";

const PaymentSuccess = () => {

    const location = useLocation();
    const navigate = useNavigate();

    return (

        <div className="paymentSuccess-overlay">

            <div className="paymentSuccess-popup">

                <button
                    className="close-btn"
                    onClick={() => navigate("/client/payment")}
                >
                    ✕
                </button>

                <div className="success-icon">
                    ✓
                </div>

                <h2 className="success-title">
                    Payment Successful
                </h2>

                <p className="success-message">
                    Your payment has been processed successfully.
                </p>

                <div className="payment-id-card">

                    <span className="payment-label">
                        Payment ID
                    </span>

                    <span className="payment-value">
                        {location?.state?.paymentId || "N/A"}
                    </span>

                </div>

                {/* <div className="success-badge">
                    🎉 Verification Request Created
                </div> */}

            </div>

        </div>
    );
};

export default PaymentSuccess;